module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/3/1-71fbb19ad1a205fda02dc4b8bf0e3c97.jpg";